export default "__VITE_ASSET__DM1VSo0R__"